// Browser wiring for BUG-523, kept apart from the tested logic in lib/appUpdate. Nothing here touches
// window until a chunk fails or main.tsx calls listen(), so the prerender can import the router.
import { createChunkReloader } from './lib/appUpdate/chunkReload'

export const chunkReloader = createChunkReloader({
  storage: () => window.sessionStorage,
  now: () => Date.now(),
  reload: () => window.location.reload(),
})
